
import type { ReadCallback } from 'i18next'

// Vite の import.meta.glob を使って `src/**/locales/{lng}/{ns}.json` を動的読み込み
// 例: src/locales/ja/common.json, src/apps/manage/locales/en/dashboard.json など
const localeGlobs = import.meta.glob('/src/**/locales/*/*.json') as Record<string, () => Promise<any>>

type BackendOptions = {
  debug?: boolean
}

class ViteBackend {
  static type = 'backend' as const
  private options: BackendOptions

  constructor(_services: unknown, options: BackendOptions = {}) {
    this.options = options
  }

  init(_services: unknown, backendOptions: BackendOptions = {}) {
    this.options = { ...this.options, ...backendOptions }
  }

  // i18next が言語+名前空間を要求した際に呼ばれる
  async read(language: string, namespace: string, callback: ReadCallback) {
    try {
      const key = this.findModuleKey(language, namespace)
      if (!key) {
        if (this.options.debug) console.warn(`[i18n] not found: ${language}/${namespace}`)
        callback(null, {})
        return
      }
      const mod = await localeGlobs[key]()
      const data = (mod?.default ?? mod) as Record<string, unknown>
      callback(null, data)
    } catch (err) {
      callback(err as Error, null)
    }
  }

  private findModuleKey(lng: string, ns: string): string | undefined {
    // 最も単純な規約: ファイル名 = 名前空間
    // 例: /src/**/locales/ja/common.json => ns: common, lng: ja
    const suffix = `/locales/${lng}/${ns}.json`
    let found: string | undefined
    for (const path of Object.keys(localeGlobs)) {
      if (path.endsWith(suffix)) {
        if (found && this.options.debug) {
          console.warn(`[i18n] duplicate namespace detected for ${lng}/${ns}:`, found, 'and', path)
        }
        found = path
      }
    }
    return found
  }
}

export default ViteBackend
